import React from 'react';

const AvailableProjects = ({type, briefs,projects, user, getSelectedProject,truncateString,formatDate, UserIcon}) => {

  return (
    <div className='available-projects-container'>
      {type === 'Brief' ? Array.isArray(briefs) &&  briefs.length > 0 &&  briefs.map((item, index) => (
            <div className='project-Card' key={index} onClick={() => getSelectedProject(item._id)} >
              <div className='briefHeaderSection'>
                <p>{item.briefTitle}</p>
              </div>

              <div className='briefDetailssection'>
                {/* First row */}
                <div className='detailsSections'>
                  <div className='profileSection' style={{ width: '60%' }}>
                    <div className='profile'>
                      <img className='profilePicture' src={UserIcon} alt='user' />
                    </div>
                    <div className='details'>
                      <p className='ValueplaceHolder'>
                        {truncateString(
                          `${item?.client?.firstName??""} ${item?.client?.lastName??""}`,
                          15
                        )}
                      </p>
                      <p className='textValue'>
                        {item?.client?.accountType === 'personal'
                          ? item?.client?.email?.length > 15
                            ? `${item?.client?.firstName??""} ${item?.client?.lastName??""}`.substring(
                                0,
                                13
                              ) + '...'
                            : item?.client?.email
                          : item?.client?.website?.length > 15
                          ? item?.client?.website?.substring(0, 13) + '...'
                          : item?.client?.website}
                      </p>
                    </div>
                  </div>

                  <div className='detailContainer' style={{ width: '40%' }}>
                    <p className='ValueplaceHolder'>Start Date</p>
                    <p className='textValue'>{formatDate(item?.projectStartDate) || ''}</p>
                  </div>
                </div>

                {/* Second row */}
                <div className='detailsSections'>
                  <div className='detailContainer' style={{ width: '60%' }}>
                    <p className='ValueplaceHolder'>Category of Service</p>
                    <p className='textValue'>
                      {item?.serviceCategory ? item?.serviceCategory : 'Not Assigned'}
                    </p>
                  </div>
                  <div className='detailContainer' style={{ width: '40%' }}>
                    <p className='ValueplaceHolder'>Fulfillment Lead</p>
                    <p className='textValue'>
                      {item?.talentPartner
                        ? `${item?.talentPartner?.firstName??""} ${item?.talentPartner?.lastName??""}`
                        : ''}
                    </p>
                  </div>
                </div>

                {/* Third row */}
                <div className='detailsSections'>
                  <div className='detailContainer' style={{ width: '60%' }}>
                    <p className='ValueplaceHolder'>Professionals</p>
                    <p className='textValue'>
                      {item?.projectPlan &&
                      Array.isArray(item.projectPlan) &&
                      item.projectPlan.length > 0 &&
                      typeof item?.projectPlan[0]?.professional === 'object'
                        ? `${item?.projectPlan[0]?.professional?.firstName??""} ${item?.projectPlan[0]?.professional?.lastName??""}`
                        : `Not Assigned`}
                    </p>
                  </div>
                  <div className='detailContainer' style={{ width: '40%' }}>
                    <p className='ValueplaceHolder'>Fulfillment Stage</p>
                    <p className='textValue'>
                      {item?.projectPlan[0]?.fulfillmentStage || 'Not Assigned'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))
        : Array.isArray(projects) && projects.length > 0 && projects.map((item, index) => (
            <div className='project-Card' key={index} onClick={() => getSelectedProject(item._id)}>
              <div className='briefHeaderSection'>
                <p>{item?.title || ''}</p>
              </div>

              <div className='briefDetailssection'>
                {/* First row */}
                <div className='detailsSections'>
                  <div className='profileSection' style={{ width: '60%' }}>
                    <div className='profile'>
                      <img className='profilePicture' src={UserIcon} alt='user' />
                    </div>
                    <div className='details'>
                      <p className='ValueplaceHolder'>
                        {truncateString(
                          `${item?.client?.firstName??""} ${item?.client?.lastName??""}`,
                          15
                        )}
                      </p>
                      <p className='textValue'>
                        {item?.client?.accountType === 'personal'
                          ? item?.client?.email?.length > 15
                            ? `${item?.client?.firstName??""} ${item?.client?.lastName??""}`.substring(
                                0,
                                13
                              ) + '...'
                            : item?.client?.email
                          : item?.client?.website?.length > 15
                          ? item?.client?.website?.substring(0, 13) + '...'
                          : item?.client?.website}
                      </p>
                    </div>
                  </div>

                  <div className='detailContainer' style={{ width: '40%' }}>
                    <p className='ValueplaceHolder'>Start Date</p>
                    <p className='textValue'>
                      {item?.projectPlan?.projStartDate
                        ? formatDate(new Date(item?.projectPlan?.projStartDate))
                        : 'No Date'}
                    </p>
                  </div>
                </div>

                {/* Second row */}
                <div className='detailsSections'>
                  <div className='detailContainer' style={{ width: '60%' }}>
                    <p className='ValueplaceHolder'>Category of Service</p>
                    <p className='textValue'>
                      {item?.serviceCategory ? item?.serviceCategory : 'Not Assigned'}
                    </p>
                  </div>
                  <div className='detailContainer' style={{ width: '40%' }}>
                    <p className='ValueplaceHolder'>Fulfillment Lead</p>
                    <p className='textValue'>
                      {item?.fulfillmentLead?.firstName?? ''}{' '}
                      {item?.fulfillmentLead?.lastName || ''}
                    </p>
                  </div>
                </div>

                {/* Third row */}
                <div className='detailsSections'>
                  <div className='detailContainer' style={{ width: '60%' }}>
                    <p className='ValueplaceHolder'>Professionals</p>
                    <p className='value'>
                      {user?.firstName??"" ?? ''} {user?.lastName??"" ?? ''}
                    </p>
                  </div>
                  <div className='detailContainer' style={{ width: '40%' }}>
                    <p className='ValueplaceHolder'>Fulfillment Stage</p>
                    <p className='textValue'>
                      {item?.projectPlan?.fulfillmentStage || 'Not Assigned'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
    </div>
  );
};

export default AvailableProjects;
